import { Button } from '@/components/Common';
import Modal from '@/components/Layout/Modal/Modal';
import { Dropdown } from 'primereact/dropdown';
import { ModalPositions } from '@/components/Layout/Modal/Modal.types';
import { useFeedback } from './useFeedback';

type FeedbackModalProps = {
  isOpen: boolean;
  onClose: () => void;
};

const FeedbackModal: React.FC<FeedbackModalProps> = ({ isOpen, onClose }) => {
  const {
    FeedbackType,
    handleCreateFeedback,
    selectedCategory,
    setSelectedCategory,
    feedbackText,
    setFeedbackText,
    feedbacks,
  } = useFeedback();

  const categoryOptions = Object.values(FeedbackType).map((type) => ({
    label: type,
    value: type,
  }));

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      position={ModalPositions.CENTER}
      modalStyle="bg-carbon p-0 max-w-[1200px]"
      headerStyle="bg-carbon h-[10px]"
    >
      <div className="p-4 md:p-6">
        <h2 className="text-white text-xl md:text-2xl font-bold mb-1">
          Feedbacks à l'IA
        </h2>
        <p className="text-slateGray text-xs md:text-sm mb-4 md:mb-6">
          Améliorer l'IA avec des prompts
        </p>

        <form onSubmit={handleCreateFeedback}>
          <div className="grid grid-cols-1 lg:grid-cols-[350px_1fr] gap-4 md:gap-8">
            <div>
              <Dropdown
                value={selectedCategory}
                onChange={(e) => setSelectedCategory(e.value)}
                options={categoryOptions}
                placeholder="Sélectionner la catégorie du feedback"
                className="w-full mb-4 bg-steel border border-onyx rounded text-white"
              />

              <textarea
                value={feedbackText}
                onChange={(e) => setFeedbackText(e.target.value)}
                placeholder="Saisir les feedbacks"
                className="w-full h-[200px] md:h-[280px] bg-offBlack border border-onyx rounded p-3 text-white resize-none"
              />
            </div>

            <div className="flex flex-col max-h-[350px] min-h-[350px] w-full min-w-[280px] md:min-w-[500px] xl:min-w-[700px] overflow-y-auto bg-iron px-4 py-2 rounded-lg">
              {feedbacks?.map((feedback) => (
                <div
                  key={feedback._id}
                  className="border-l-4 border-yellow-500 bg-black p-3 md:p-4 mb-3 md:mb-4 relative"
                >
                  <div className="text-white text-xs md:text-sm mb-1 w-[90%]">
                    {feedback.feedbacks}
                  </div>
                  <div className="text-slateGray text-[10px] md:text-xs">
                    Feedback {feedback.category}
                  </div>
                  <div className="absolute right-2 top-2 bg-mariGold size-[28px] md:size-[36px] flex items-center justify-center rounded-full">
                    <i className="pi pi-trash text-primary text-[10px] md:text-xs"></i>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <Button
            title="Ajouter"
            type="submit"
            className="!bg-yellow-500 !text-black ml-0 md:ml-[120px] mt-4 md:mt-6"
          />
        </form>
        <div className="flex justify-end items-center mt-4 md:mt-6">
          <div className="flex gap-2 md:gap-3">
            <Button
              title="Annuler"
              onClick={onClose}
              className="!bg-red-700 !text-white !px-4 md:!px-8"
            />
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default FeedbackModal;
